<template>
  <button
    class="btn btn-default dropdown_opener"
    :class="styles"
    type="button"
    :disabled="disabled"
    @click="onClick"
    @keydown.enter.prevent="onClick"
    @keydown="arrowKeyDown"
    ref="btn"
  >
    <span class="dropdown_placeholder" v-if="placeholder">{{ placeholder }}</span>
    <span class="dropdown_label">{{ selectedLabel }}</span>
    <base-icon icon-name="down" />
  </button>
</template>

<script>
export default {
  name: 'DropdownCustomOpener',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    selectedLabel: {
      type: String,
      default: '',
    },
    isOpen: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
  },
  computed: {
    placeholderActive() {
      return this.isOpen || this.selectedLabel
    },
    styles() {
      return {
        'dropdown_opener--active': this.isOpen,
        'dropdown_opener--placeholder-active': this.placeholderActive,
      }
    }
  },
  methods: {
    focus() {
      this.$refs.btn.focus();
    },
    onClick(e) {
      if (e?.pointerId === -1) return;
      this.$emit('handle-click')
    },
    arrowKeyDown(e) {
      switch (e.key) {
        case 'Escape':
          this.$emit('close');
          break;
        case 'ArrowDown':
          e.preventDefault();
          if (this.isOpen) this.$emit('focus-first');
          break;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.dropdown_opener {
  @include font-styles('Futura W01 Book', 400);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  font-size: 16px;
  border: 1px solid $color-grey;
  color: $color-text-grey;
  position: relative;
  padding-right: 5px;
  border-radius: 10px;
  .icons {
    font-size: 19px;
    transition: transform .3s, color .3s;
    position: absolute;
    right: 0px;
  }
  &.dropdown_opener--active,
  &:hover,
  &:focus,
  &:active {
    background-color: transparent;
    outline: none;
    border-color: $color-active-blue;
    box-shadow: inset 0 0 0 1px $color-active-blue;
  }
  &.dropdown_opener--active {
    .icons {
      transform: rotateX(180deg);
      color: $color-active-blue;
    }
  }
}
.dropdown_label {
  background-color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dropdown_placeholder {
  position: absolute;
  max-width: 90%;
  padding: 0 8px;
  transform: translateX(-8px);
  background-color: #fff;
  transition: transform .3s, color .3s;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  .dropdown_opener--active & {
    color: $color-active-blue;
  }
  .dropdown_opener--placeholder-active & {
    transform: translate(-16px, -24px) scale(0.75);
    text-overflow: unset;
    overflow: visible;
    max-width: none;
  }
}
</style>
